import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { createTask, selectTask, openStats } from '../../redux/slices/tasksSlice';

export default function TaskList() {
    const dispatch = useAppDispatch();
    const { items, selectedKey, panel, loadStatus } = useAppSelector((state) => state.tasks);

    return (
        <aside className="task-sidebar">
            <button className="task-btn task-btn--primary" onClick={() => dispatch(createTask())}>
                + Создать новое задание
            </button>

            {loadStatus === 'loading' && <p className="task-hint">Загрузка заданий…</p>}
            {loadStatus === 'failed' && (
                <p className="task-error">Не удалось загрузить задания с сервера</p>
            )}
            {loadStatus !== 'loading' && items.length === 0 && (
                <p className="task-hint">Заданий пока нет</p>
            )}

            <ul className="task-list">
                {items.map((task) => {
                    const isSelected = task.key === selectedKey;
                    const isSaved = task.id != null;
                    return (
                        <li key={task.key} className="task-list__row">
                            <button
                                className={'task-list__item' + (isSelected && panel === 'editor' ? ' is-active' : '')}
                                onClick={() => dispatch(selectTask(task.key))}
                                title={task.title}
                            >
                                <span className="task-list__name">{task.title || 'Без названия'}</span>
                                {task.isDirty && <span className="task-list__dot" title="Не сохранено" />}
                            </button>
                            <button
                                className={'task-list__stats' + (isSelected && panel === 'stats' ? ' is-active' : '')}
                                onClick={() => dispatch(openStats(task.key))}
                                disabled={!isSaved}
                                title={isSaved ? 'Посмотреть статистику' : 'Статистика будет доступна после сохранения'}
                                aria-label="Посмотреть статистику"
                            >
                                <svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true">
                                    <rect x="2" y="9" width="3" height="5" rx="0.5" fill="currentColor" />
                                    <rect x="6.5" y="5" width="3" height="9" rx="0.5" fill="currentColor" />
                                    <rect x="11" y="2" width="3" height="12" rx="0.5" fill="currentColor" />
                                </svg>
                            </button>
                        </li>
                    );
                })}
            </ul>
        </aside>
    );
}
